
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-ef83ba4c\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"./src/styles\"],\"data\":\"@import \\\"./src/styles/common\\\";\",\"sourceMap\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PersonInfo.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PersonInfo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ef83ba4c\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PersonInfo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/personalCenter/PersonInfo.vue
// module id = 1013
// module chunks = 1